import { FC } from 'react';

import { DefaultRewardCalendar } from '@appcharge/shared-ui';
import useOffersUI from 'api/useOffersUI';
import { ERewardCalendarPopUpTrigger } from 'constants/enums';
import { REWARD_CALENDAR_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';
import { POPUP_CONTAINER_STYLE } from 'views/OfferDesign/pages/OfferDesignForm/components/OfferDesignPreview/OfferDesignPreview.consts';
import { OfferPreviewShell } from 'views/Offers/components/OfferPreviewShell';

const REWARD_CALENDAR_MOCK_ID = 'iphone-mock-reward-calendar';

export interface RewardCalendarPreviewSequenceItem {
  index: number;
  products: {
    images: { product: string };
    quantity: number;
    quantityDisplay: string;
  }[];
}

interface RewardCalendarPreviewProps {
  publisherId?: string;
  currentOfferUI: string;
  productsSequence: RewardCalendarPreviewSequenceItem[];
}

export const RewardCalendarPreview: FC<RewardCalendarPreviewProps> = ({
  publisherId,
  currentOfferUI,
  productsSequence
}) => {
  const { getOfferUI } = useOffersUI(publisherId, currentOfferUI);
  const offerData = getOfferUI?.data;
  const rc = offerData?.rewardCalendar;

  const backgroundColor = rc?.backgroundColor || REWARD_CALENDAR_DEFAULTS.backgroundColor;

  return (
    <OfferPreviewShell
      containerId={REWARD_CALENDAR_MOCK_ID}
      containerStyle={POPUP_CONTAINER_STYLE}
      containerClassName="[&_.MuiBackdrop-root]:!bg-transparent"
    >
      {() => {
        if (!offerData) return null;

        return (
          <DefaultRewardCalendar
            isPreview
            showCloseButton={false}
            dataTestId="reward-calendar-preview"
            buttonText="Collect"
            isAllowedToCollect
            indexToCollect={2}
            productsSequence={productsSequence}
            rewardCalendar={{
              unlockedIndex: 2,
              nextUnlockAt: new Date(Date.now() + 60 * 60 * 1000),
              popupTrigger: ERewardCalendarPopUpTrigger.SHOW_AUTOMATICALLY as never
            }}
            rewardCalendarUi={{
              headerImage: rc?.headerImage || '',
              collectibleBadgeImage:
                rc?.collectibleBadgeImage ||
                REWARD_CALENDAR_DEFAULTS.collectibleBadgeImage,
              lockedBadgeImage:
                rc?.lockedBadgeImage ||
                REWARD_CALENDAR_DEFAULTS.lockedBadgeImage,
              backgroundColor,
              dayFontColor:
                rc?.dayFontColor || REWARD_CALENDAR_DEFAULTS.dayFontColor,
              subRewardBackgroundImage: rc?.subRewardBackgroundImage || '',
              mainRewardBackgroundImage: rc?.mainRewardBackgroundImage || '',
              collectedIconImage:
                rc?.collectIconImage ||
                REWARD_CALENDAR_DEFAULTS.collectIconImage,
              lockedIconImage:
                rc?.lockedIconImage || REWARD_CALENDAR_DEFAULTS.lockedIconImage
            }}
            onCollect={() => Promise.resolve(true)}
            modalContainer={() =>
              document.getElementById(REWARD_CALENDAR_MOCK_ID)
            }
          />
        );
      }}
    </OfferPreviewShell>
  );
};
